
        import React from 'react';
        import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new SpriteSymbol({
  "id": "done.sprite",
  "use": "done.sprite-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol viewBox=\"0 0 56 56\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done.sprite\">\n <path d=\"m28 4.667c-12.83 0-23.33 10.5-23.33 23.33s10.5 23.33 23.33 23.33 23.33-10.5 23.33-23.33-10.5-23.33-23.33-23.33zm-3.967 32.67-7.7-7.7 3.267-3.267 4.433 4.433 12.37-12.37 3.267 3.267z\" fill-rule=\"evenodd\" />\n</symbol>"
});
        sprite.add(symbol);

        const DoneSpriteSpriteSymbol = props => (
            <svg {...props} viewBox='0 0 56 56'>
                <use xlinkHref='#done.sprite' />
            </svg>
        );
        export default DoneSpriteSpriteSymbol;
  